import { forwardRef } from 'react';
import { array, node, number, object, oneOfType, string } from 'prop-types';

import Text from '../Text/Text';

const Error = forwardRef(
  ({ mt, children, ...props }, ref) =>
    children && (
      <Text ref={ref} mt={mt} {...props}>
        {children}
      </Text>
    )
);

Error.propTypes = {
  color: oneOfType([string, array, object]),
  fontSize: oneOfType([number, string, array, object]),
  mt: oneOfType([number, string, array, object]),
  children: node
};

Error.defaultProps = {
  color: 'red',
  fontSize: 1,
  mt: 1,
  children: null
};

export default Error;
